import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';

const routes =  [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        props: { msg: "This is not the correct url for your survey" }
    },  
    {
        path: "/public-form",
        name: "PublicForm",
        component: () => import("./../src/views/PublicPages/PublicForm.vue"),
        meta: {
            auth: false, 
            title: "Public Form",
            noLayout: true 
        },
        props: true
    },
    {
        path: "/public-survey",
        name: "PublicSurvey",
        component: () => import("./../src/views/PublicSurvey/PublicSurvey.vue"),
        meta: {
            auth: false, 
            title: "Public Survey",
            noLayout: true 
        },
        props: true
    },
];


const router =createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const defaultTitle = 'Survey Form';
    document.title = to.meta.title || defaultTitle;
    next();
  });

export default router;